import { useQuery } from '@apollo/client/react'
import { useSearchParams } from 'react-router-dom'
import Heading from '@components/heading/heading'
import Pagination from '@components/pagination/pagination'
import Search from '@components/requests/search'
import Table from '@components/requests/table'
import GET_REQUESTS from '@graphql/queries/get-requests'
import Error from '@components/Error/Error'

function List() {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchFilters = Object.fromEntries(searchParams)
  const { data, error, loading, refetch, fetchMore } = useQuery(GET_REQUESTS, {
    variables: { filters: searchFilters }
  })

  return (
    <>
      <Heading heading='Requests' />
      {error ? (
        <Error error={error} />
      ) : (
        <>
          <Search
            refetch={refetch}
            searchFilters={searchFilters}
            setSearchParams={setSearchParams}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.requests?.metadata}
          />
          <Table
            totalCount={data?.requests?.metadata?.totalCount}
            requests={data?.requests?.collection || []}
            loading={loading}
          />
        </>
      )}
    </>
  )
}

export default List
